import React, {useCallback} from 'react';
import {BackButtonIcon} from '../../icons/Icons';
import {useNavigate} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';

function BackButton({to}:{to?:string}) {
    const navigate = useNavigate();
    const onClick = useCallback(()=>{
        to ? navigate(to) : navigate(-1)
    },[navigate, to])

    return (<button className={'btn d-flex px-0 text-sm text-dark row no-gutters align-items-center'} onClick={onClick}>
        <div className={'col-auto'}>
            <BackButtonIcon/>
        </div>
        <div className={'col-auto'}>
            <span className={'ml-2'}><FormattedMessage id={"Go Back"}/></span>
        </div>
    </button>);
}
export default BackButton
